import { SizableText, XStack } from '@mythical/ui'
import { ComingUp } from 'app/blocks/homepage/coming-up'
import ContentCardUpcoming, {
  ContentCardUpcomingProps,
} from 'app/components/content/ContentCardUpcoming'
import { ContentCarousel } from 'app/components/content/ContentCarousel'
import { Button } from 'app/components/primitive/Button'
import {
  IconChevronLeft,
  IconChevronRight,
} from 'app/components/primitive/Icon'
import Section from 'app/components/structure/Section'
import { useCarouselController } from 'app/hooks/use-carousel-controller'
import React, { useCallback, useMemo } from 'react'

export const ComingUpBlock: React.FC<{ block: ComingUp }> = ({ block }) => {
  const { title, comingUp } = block || {}

  const { carouselRef, ...controller } = useCarouselController()

  if (!comingUp || comingUp?.length === 0) {
    return null
  }

  const processed = useMemo(
    () =>
      comingUp.map((item): ContentCardUpcomingProps => {
        return {
          ...item,
          id: item.id,
          title: item.name,
          dateReleaseStart: item.startDate,
          dateReleaseEnd: item.endDate,
          contentTier: item.degree,
          image: item.thumbnail.sizes?.thumbnail?.url,
        }
      }),
    [comingUp],
  )

  const renderItem = useCallback(
    (item: ContentCardUpcomingProps) => <ContentCardUpcoming {...item} />,
    [],
  )

  const keyExtractor = useCallback(
    (item: ContentCardUpcomingProps) => item.id,
    [],
  )

  return (
    <Section
      paddedX
      title={title || 'Coming up on the society'}
      customCta={
        <XStack gap="$2" $sm={{ dsp: 'none' }}>
          <Button
            theme="white"
            onPress={controller.scrollToPrevious}
            disabled={!controller.canScrollPrevious}
            aria-label="Previous"
            icon={<IconChevronLeft size={16}  />}
            size="$3.5"
            circular
          />
          <Button
            theme="white"
            onPress={controller.scrollToNext}
            disabled={!controller.canScrollNext}
            aria-label="Next"
            circular
            size="$3.5"
            icon={<IconChevronRight size={16}  />}
          />
        </XStack>
      }
    >
      {processed?.length > 0 && (
        <ContentCarousel
          items={processed}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          controllerRef={carouselRef}
        />
      )}
      {processed?.length === 0 && (
        <SizableText textTransform="uppercase" color="$fgSecondary">
          No upcoming content found
        </SizableText>
      )}
    </Section>
  )
}
